import React, { useState } from "react";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

// @material-ui/lab components
// @material-ui/icons components
// core components
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import { pushNotification } from "../../network/ApiAxios";
import { ArrowBack } from "@material-ui/icons";
import { Tooltip } from "@material-ui/core";
import "react-datepicker/dist/react-datepicker.css";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const PushNotification = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [showError, setShowError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [target, setTarget] = useState("");
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [executeSend, setExecuteSend] = useState(false);
  let history = useHistory();
  
  const warningAlert = (title,message,action) => {
    setAlert(
      <ReactBSAlert
        info
        style={{ display: "block", marginTop: "-100px" }}
        title={title}
        onConfirm={action}
        onCancel={() => setAlert(null)}
        showCancel="true"
        cancelBtnBsStyle="warning"
        cancelBtnText="No"
        confirmBtnBsStyle="success"
        confirmBtnText="Yes"
        btnSize=""
        confirmBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
        cancelBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
      >
        {message}
      </ReactBSAlert>
    );
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
  };


  const clearCurrentRecord = () => {
    setTarget("");
  setTitle("");
  setBody("");
  };


  const pushNotificationAction = async () => {
    setIsLoading(true);
    try{
    const response = await pushNotification(title,body,target);
    const { data } = response;
    setIsLoading(false);
    if (data.result.isSuccess) {
      showSuccessNotification("Notification Pushed Successfully");
    } else {
      showErrorNotification(data.result.description);
    }
    }
    catch(ex){
      showErrorNotification("Failed to push notification");
      setIsLoading(false);
    }
  };



  useAsyncEffect(async () => {
    if(executeSend){
      pushNotificationAction();
    }
  }, [executeSend]);

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >

        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                    <Tooltip title="Back">
                        <Button
                          size="small"
                          classes={{
                            root: classes.buttonContainedPrimary,
                          }}
                          variant="contained"
                          style={{ marginRight: "20px" }}
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <Box component={ArrowBack} />
                        </Button>
                      </Tooltip>
                      <Box component="span">Send Push Notification</Box>
                    </Box>
                  </>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>
              <div style={{ margin: "20px"}}>
              
              <form>
              <FormGroup>
                  <FormLabel>Target</FormLabel>
                  <code>Enter GLOBAL to send for all users or enter a list of User Ids comma seperated without leading C</code>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Target"
                    value={target ?? ""}
                    onChange={(e) => setTarget(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <FormLabel>Notification Title</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Title"
                    value={title ?? ""}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <FormLabel>Notification Body</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Body"
                    value={body ?? ""}
                    multiline={true}
                    rows={5}
                    onChange={(e) => setBody(e.target.value)}
                  />
                </FormGroup>
                </form>

                {isLoading ? (<Box component={Grid} container justifyContent="center" className="justify-content-center" ><div className="text-center" style={{ width: "10%" }} ><LoadingAnimation /></div></Box>) : (<Button
                fullWidth
                      onClick={() =>
                        pushNotificationAction()
                      }
                      
                  classes={{
                    root: classes.buttonContainedPurple100,
                  }}
                      variant="contained"
                    >
                      Send
                    </Button>
                )
                  }
                  
              </div>
            </Card>
          </Grid>
        </Grid>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default PushNotification;
